import React, { PureComponent, Fragment } from 'react'
import PropTypes from 'prop-types'
import actions from 'redux/actions'
import { modals, getTextByCount } from 'helpers'
import { connect } from 'redaction'

import Box from 'components/layout/Box/Box'
import Modal from 'components/Modal/Modal'
import Button from 'components/ui/Button/Button'
import Loader from 'components/ui/Loader/Loader'
import { Grid, Cell } from 'components/layout/grid'

import Post from './Post/Post'

import s from './VoteModal.scss'


class VoteModal extends PureComponent {

  static propTypes = {
    name: PropTypes.string.isRequired,
    data: PropTypes.object.isRequired,
  }

  static defaultProps = {
    name: modals.Vote,
  }

  UNSAFE_componentWillMount() {
    const { data: { id } } = this.props

    actions.voting.homePage.fetchProject(id)
  }

  close = () => {
    const { name } = this.props

    actions.modals.close(name)
  }

  handleVoteClick = () => {
    const { data: { onVoteClick } } = this.props

    this.close()

    if (typeof onVoteClick === 'function') {
      onVoteClick()
    }
  }

  render() {
    const { data: { id, votes, isButtonDisabled }, project: { post } } = this.props

    const votesCount = typeof votes === 'object' ? 0 : votes

    return (
      <Modal
        closeBtn={Boolean(post)}
        onClose={this.close}
      >
        <div className={s.voteModal}>
          {
            Boolean(post && post.id === id) ? (
              <Fragment>
                <Post
                  post={{
                    ...post,
                    author: post.author ? `${post.author.firstName} ${post.author.lastName}` : '',
                  }}
                >
                  <Grid className={s.grid} columns={2}>
                    <Cell size={1}>
                      <Button
                        title="Проголосовать"
                        green
                        disabled={isButtonDisabled}
                        onClick={this.handleVoteClick}
                      />
                    </Cell>
                    <Cell size={1}>
                      <Box alignRight>
                        <div>
                          {getTextByCount({ count: votesCount, one: 'Проголосовал', two: 'Проголосовало', other: 'Проголосовало'})}
                        </div>
                        <div>
                          <span className={s.number}>{votesCount}</span>
                          &nbsp;{getTextByCount({ count: votesCount, one: 'человек', two: 'человека', other: 'человек'})}
                        </div>
                      </Box>
                    </Cell>
                  </Grid>
                </Post>
              </Fragment>
            ) : (
              <Loader className={s.loader} />
            )
          }
        </div>
      </Modal>
    )
  }
}


export default connect({
  project: (state, props) => state.voting.homePage.project,
})(VoteModal)
